import { useTranslation } from 'react-i18next';
import type { StudySubjectListSource } from '@/clinical-study/subjects/useStudySubjectList';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CalendarAgendaView } from './StudyCalendarAgenda';

/**
 * «Calendario» on the study page (#893): every subject's treatment dates and visits, plus the
 * treatment dates that still have available slots, as one read-only agenda by day. The subject list
 * and the permissions arrive from the page, which owns their single reads; a failed subject list
 * is already reported, with its own retry, by the subjects section below.
 */
export function StudyCalendarSection({
  studyId,
  subjectList,
  canReadSchedules,
  canReadPool,
  onOpenSubject,
}: {
  studyId: string;
  subjectList: StudySubjectListSource;
  canReadSchedules: boolean;
  canReadPool: boolean;
  onOpenSubject: (subjectId: string) => void;
}) {
  const { t } = useTranslation('clinical-study');
  return (
    <Card>
      <CardHeader>
        <CardTitle asChild>
          <h3>{t('calendar.title')}</h3>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-sm text-muted-foreground">{t('calendar.description')}</p>
        <CalendarAgendaView
          studyId={studyId}
          subjectList={subjectList}
          canReadSchedules={canReadSchedules}
          canReadPool={canReadPool}
          onOpenSubject={onOpenSubject}
          reportListError={false}
        />
      </CardContent>
    </Card>
  );
}
